import React from 'react';

export function SearchProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}